/* eslint-disable max-lines  */
import { QB_DRAG_TYPES, QB_GROUP_CONDITION_TYPES, QB_FIELD_SHARED_ACTIONS } from './types.js';

/**
 * this is injected. instance of QBStore
 * @param {*} idGroup: UUID
 * @param idGroup
 */
export const createNewFilter = function (idGroup) {
  const idFilter = `filter_${new Date().getTime()}_${Math.random().toString(36).substring(7)}`;
  return {
    idGroup,
    field: '',
    condition: '',
    value: '',
    idFilter,
    type: QB_DRAG_TYPES.FILTER,
  };
};

/**
 * this is injected. instance of QBStore
 * @param {*} parentIdGroup: UUID
 * @param parentIdGroup
 */
export const createNewGroup = function (parentIdGroup) {
  const idGroup = `group_${new Date().getTime()}_${Math.random().toString(36).substring(7)}`;
  return {
    parentIdGroup,
    idGroup,
    condition: QB_GROUP_CONDITION_TYPES.AND,
    type: QB_DRAG_TYPES.GROUP,
  };
};

/**
 * this is injected. instance of QBStore
 * @param {*} newFilter
 */
export const addFilterToMap = function (newFilter) {
  this.mapFilters = {
    ...this.mapFilters,
    [newFilter.idFilter]: newFilter,
  };
};

/**
 * this is injected. instance of QBStore
 * @param {*} newFilter
 * @param newGroup
 */
export const addGroupToMap = function (newGroup) {
  this.mapGroups = {
    ...this.mapGroups,
    [newGroup.idGroup]: {
      ...newGroup,
    },
  };
};

export const addFilterToItem = function (item, newFilter) {
  item.children.push({
    id: newFilter.idFilter,
    element: newFilter,
    children: [],
  });
};

export const addFilterToMainItem = function (items, newFilter) {
  items.push({
    id: newFilter.idFilter,
    element: newFilter,
    children: [],
  });
};

export const findInChilds = function (childs, filterId) {
  const found = childs.find(({ id }) => id === filterId);
  if (!found) {
    let findInChild;
    childs.forEach((item) => {
      if (!findInChild) findInChild = findInChilds(item.children, filterId);
    });
    if (findInChild) return findInChild;
  }
  return found;
};
export const findItemFilterById = function (filterId) {
  return findInChilds(this.items, filterId);
};

export const findParentWithFilterId = function (childs, filterId) {
  const found = childs.find(({ id }) => id === filterId);
  if (!found) {
    let findInChild;
    childs.forEach((item) => {
      if (!findInChild) findInChild = findParentWithFilterId(item.children, filterId);
    });
    if (findInChild) return findInChild;
  }
  return childs;
};
export const findParentFilterById = function (filterId) {
  return findParentWithFilterId(this.items, filterId);
};

export const filterInChildren = function (childs, filterId, mainId) {
  if (childs.children) {
    childs.children = childs.children.filter(({ id }) => id !== filterId);
    childs.children = childs.children.forEach((item) => filterInChildren(item.children, filterId));
    return childs;
  }
  // main
  if (childs.length > 1) childs = childs.filter(({ id }) => id !== filterId); // https://jira.elliemae.io/browse/PUI-1252
  if (childs.length === 0 && mainId) {
    const emptyFilter = createNewFilter.call(this, mainId);
    addFilterToMainItem.call(this, childs, emptyFilter);
  }
  childs.forEach((item) => (item.children = filterInChildren(item.children, filterId)));
  return childs;
};
export const removeFilterItem = function (filterId) {
  this.items = filterInChildren(this.items, filterId, this.main);
};

export const addGroupFilterToItem = function (idGroup, idFilter, newGroup) {
  const child = findItemFilterById.call(this, idFilter);
  const copy = {
    ...child,
  };
  if (copy.element.type === 'group') {
    copy.element.parentIdGroup = newGroup.idGroup;
  } else {
    copy.element.idGroup = newGroup.idGroup;
  }
  child.id = newGroup.idGroup;
  child.element = newGroup;
  child.children = [copy];
};

export const unGroupFilterToItem = function (idGroup) {
  const group = findItemFilterById.call(this, idGroup);
  if (group.element.parentIdGroup === this.main) {
    const index = this.items.map((item) => item.id).indexOf(idGroup);
    const tmp = [];
    tmp.splice.apply(this.items, [index, 1].concat(group.children));
    this.items.forEach((item) => {
      if (item.element.type === 'group') {
        item.element.parentIdGroup = this.main;
      } else {
        item.element.idGroup = this.main;
      }
    });
  } else {
    const parent = findItemFilterById.call(this, group.element.parentIdGroup);
    const index = parent.children.map((item) => item.id).indexOf(idGroup);
    const tmp = [];
    tmp.splice.apply(parent.children, [index, 1].concat(group.children));
    parent.children.forEach((item) => {
      if (item.element.type === 'group') {
        item.element.parentIdGroup = parent.id;
      } else {
        item.element.idGroup = parent.id;
      }
    });
  }
};

export const changeGroupOperator = function (idGroup, value) {
  const group = findItemFilterById.call(this, idGroup);
  if (idGroup !== this.main) {
    group.element.condition = value;
  }
};

export const changeFilterItem = function ({
  idFilter,
  field,
  value,
  operator,
  additionalInfo,
  target,
  fieldsSharedActions: { onFieldChange, onOperatorChange, onValueChange },
}) {
  const child = findItemFilterById.call(this, idFilter);
  if (field || field === '' || typeof field === 'boolean') child.element.field = field;
  if (operator) child.element.operator = operator;
  if (value || value === '' || typeof value === 'boolean') child.element.value = value;
  if (additionalInfo) child.element.additionalInfo = additionalInfo;

  // shared fields actions
  if (target === 'field') {
    onFieldChange.forEach(({ action }) => {
      if (action === QB_FIELD_SHARED_ACTIONS.RESET_FIELD) child.element.field = null;
      else if (action === QB_FIELD_SHARED_ACTIONS.RESET_OPERATOR) child.element.operator = null;
      else if (action === QB_FIELD_SHARED_ACTIONS.RESET_VALUE) child.element.value = null;
    });
  } else if (target === 'operator') {
    onOperatorChange.forEach(({ action }) => {
      if (action === QB_FIELD_SHARED_ACTIONS.RESET_FIELD) child.element.field = null;
      else if (action === QB_FIELD_SHARED_ACTIONS.RESET_OPERATOR) child.element.operator = null;
      else if (action === QB_FIELD_SHARED_ACTIONS.RESET_VALUE) child.element.value = null;
    });
  } else if (target === 'value') {
    onValueChange.forEach(({ action }) => {
      if (action === QB_FIELD_SHARED_ACTIONS.RESET_FIELD) child.element.field = null;
      else if (action === QB_FIELD_SHARED_ACTIONS.RESET_OPERATOR) child.element.operator = null;
      else if (action === QB_FIELD_SHARED_ACTIONS.RESET_VALUE) child.element.value = null;
    });
  }
};
